<template>
  <div class="step-1">
    <i-calendar
      :timezone="bookings.timezone"
      :active-range="activeRange"
      :active-times="activeTimes"
      @select="onSelect"
    />
  </div>
</template>

<script>
import ICalendar from '@/components/ICalendar'

const hours = [...Array(24).keys()].map(val => (val < 10 ? '0' + val : val) + ':00')

export default {
  name: 'BookingStep1',
  components: {
    ICalendar
  },
  props: {
    calendar: {
      type: Boolean,
      default: false
    },
    bookings: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    timeout: null
  }),
  computed: {
    activeRange () {
      // common might be empty if the admin hasn't save changes at editor
      const from = this.bookings.common ? this.bookings.common.from : undefined
      const to = this.bookings.common ? this.bookings.common.to : undefined
      const startIndex = from ? hours.indexOf(from) : 0
      const endIndex = to ? hours.indexOf(to) : hours.length - 1
      return hours.slice(startIndex, endIndex + 1)
    },
    activeTimes () {
      let value = []
      Object.keys(this.bookings.detail || {}).forEach(date => {
        const times = this.bookings.detail[date]
        const datetimes = times.map(time => date + ' ' + time)
        value = value.concat(datetimes)
      })
      return value
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  },
  methods: {
    onSelect (val) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$emit('next', {
          date: val
        })
      }, 300)
    }
  }
}
</script>
